import React, { createContext, useContext, useState, useMemo } from "react";

const ContextPanelSheetContext = createContext({
  contextPanelOpen: false,
  setContextPanelOpen: () => {},
});

export const useContextPanelSheet = () => useContext(ContextPanelSheetContext);

export const ContextPanelSheetProvider = ({ children }) => {
  const [contextPanelOpen, setContextPanelOpen] = useState(false);

  // Memoize context value to prevent unnecessary re-renders
  const value = useMemo(() => ({ contextPanelOpen, setContextPanelOpen }), [contextPanelOpen]);

  return (
    <ContextPanelSheetContext.Provider value={value}>
      {children}
    </ContextPanelSheetContext.Provider>
  );
};
